
import ApiClient from './apiClient';
import { GetDataFromDBDTO, NewOrderRequest, UpdateProfileDTO } from 'types/dto/order';


export const fetchServiceType = async (module: string, lang: string) => {
  const response = await ApiClient.getInstance().get({
    url: `${module}/getservicetype`,
    params: { lang: lang },
  });
  return response.data;
};

export const fetchCollectionItems = async (module: string, lang: string) => {
  const response = await ApiClient.getInstance().get({
    url: `${module}/getcollectionitems`,
    params: { lang: lang },
  });
  return response.data;
};

export const fetchPickupMethodsItems = async (module: string, lang: string) => {
  const response = await ApiClient.getInstance().get({
    url: `${module}/getpickupmethods`,
    params: { lang: lang },
  });
  return response.data;
};

export const fetchAddress = async (module: string, dto: GetDataFromDBDTO) => {
  const response = await ApiClient.getInstance().post({
    url: `${module}/getaddress`,
    data: dto,
  });
  return response.data;
};

export const saveAddress = async (module: string, dto: UpdateProfileDTO) => {
  const response = await ApiClient.getInstance().post({
    url: `${module}/updateAddress`,
    data: dto,
  });
  return response.data;
};

export const fetchCheckPromotion = async (module: string, promotioncode: string) => {
  const response = await ApiClient.getInstance().get({
    url: `${module}/checkpromotion`,
    params: { promotioncode: promotioncode },
  });
  return response.data;
};

export const fetchPickupSchedule = async (module: string, locationCode: string) => {
  const response = await ApiClient.getInstance().get({
    url: `${module}/getpickupschedule`,
    params: { locationCode: locationCode },
  });
  return response.data;
};

export const addOrder = async (module: string, dto: NewOrderRequest) => {
  const response = await ApiClient.getInstance().post({
    url: `${module}/addorder`,
    data: dto,
  });
  return response.data;
};

export const fetchDistrict = async (module: string, lang: string) => {
  const response = await ApiClient.getInstance().get({
    url: `${module}/getdistrict`,
    params: { lang: lang },
  });
  return response.data;
};